import createReducer from './createReducer';
var initialState = {
  mainCurrencies: []
};
var currencies = createReducer(initialState, {});
export default currencies;